import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analisis-estrategico/AnalisisEstrategicoClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
